import { render, staticRenderFns } from "./MonthlySocsoAmbank.vue?vue&type=template&id=084305c4&scoped=true"
import script from "./MonthlySocsoAmbank.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoAmbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084305c4",
  null
  
)

export default component.exports